import {
  CLEAR_AMLS_COMMON_UNIFIED_ALERTS,
  GET_AMLS_COMMON_UNIFIED_ALERTS,
  GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS,
  GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL,
  GET_AMLS_COMMON_KYC_ALERTS,
  GET_AMLS_COMMON_KYC_ALERTS_SUCCESS,
  GET_AMLS_COMMON_KYC_ALERTS_FAIL,
  GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD,
  GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_SUCCESS,
  GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_FAIL,
  GET_AMLS_COMMON_ALERT_DETAILS,
  GET_AMLS_COMMON_ALERT_DETAILS_SUCCESS,
  GET_AMLS_COMMON_ALERT_DETAILS_FAIL,
  GET_AMLS_COMMON_ALERT_PARTY_IDENTITY,
  GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_SUCCESS,
  GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_FAIL,
  GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS,
  GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_SUCCESS,
  GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_FAIL,
  PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
  PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_SUCCESS,
  PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_FAIL,
  RESET_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
  GET_AMLS_COMMON_TICKETS,
  GET_AMLS_COMMON_TICKETS_SUCCESS,
  GET_AMLS_COMMON_TICKETS_FAIL,
  PUT_AMLS_COMMON_ALERT_PARTY_UPDATE,
  PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_SUCCESS,
  PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_FAIL,
  GET_AMLS_COMMON_SANDBOX_UI_FAIL,
  GET_AMLS_COMMON_SANDBOX_UI_SUCCESS,
  GET_AMLS_COMMON_SANDBOX_UI,
  RESET_AMLS_COMMON_SANDBOX_UI_RESULTS,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_SUCCESS,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_FAIL,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_SUCCESS,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_FAIL,
  PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE,
  PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_SUCCESS,
  PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_FAIL,
  PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_RESET,
  GET_AMLS_COMMON_PIPELINES,
  GET_AMLS_COMMON_PIPELINES_SUCCESS,
  GET_AMLS_COMMON_PIPELINES_FAIL,
  POST_AMLS_COMMON_PIPELINES_RUN,
  POST_AMLS_COMMON_PIPELINES_RUN_SUCCESS,
  POST_AMLS_COMMON_PIPELINES_RUN_FAIL,
  RESET_AMLS_COMMON_DYNAMIC_PROPERTIES,
  POST_AMLS_COMMON_PIPELINES_SCHEDULE,
  POST_AMLS_COMMON_PIPELINES_SCHEDULE_SUCCESS,
  POST_AMLS_COMMON_PIPELINES_SCHEDULE_FAIL,
  POST_AMLS_COMMON_PIPELINES_UNSCHEDULE,
  POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_SUCCESS,
  POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_FAIL,
  GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO,
  GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_SUCCESS,
  GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_FAIL,
  GET_AMLS_COMMON_PIPELINES_HISTORY,
  GET_AMLS_COMMON_PIPELINES_HISTORY_SUCCESS,
  GET_AMLS_COMMON_PIPELINES_HISTORY_FAIL,
  POST_AMLS_COMMON_PIPELINE_STOP,
  POST_AMLS_COMMON_PIPELINE_STOP_SUCCESS,
  POST_AMLS_COMMON_PIPELINE_STOP_FAIL,
  FETCH_TRM_ACTIONS_OF_TYPOLOGIES,
  FETCH_TRM_ACTIONS_OF_TYPOLOGIES_SUCCESS,
  FETCH_TRM_ACTIONS_OF_TYPOLOGIES_FAIL,
  GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION,
  GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS_PREVENTION,
  GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL_PREVENTION,
  CLEAR_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION,
  GET_AMLS_COMMON_NOTIFICATIONS,
  GET_AMLS_COMMON_NOTIFICATIONS_SUCCESS,
  GET_AMLS_COMMON_NOTIFICATIONS_FAIL,
  FETCH_AMLS_ALERT_LEVEL,
  FETCH_AMLS_ALERT_LEVELS_FAIL,
  FETCH_AMLS_ALERT_LEVELS_SUCCESS,
  GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS,
  GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_SUCCESS,
  GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_FAIL
} from '../actions/common';

export const initialState = {
  unifiedAlerts: {
    isLoading: true,
    error: null,
    data: null
  },
  unifiedAlertCounts: {
    isLoading: false,
    error: null,
    data: null
  },
  unifiedAlertsPrevention: {
    isLoading: true,
    error: null,
    data: null
  },
  alertPartyIdentity: {
    isLoading: true,
    error: null,
    data: null
  },
  alertDetails: {
    isLoading: true,
    error: null,
    data: null
  },
  alertAssocCustomers: {
    isLoading: true,
    error: null,
    data: null
  },
  tickets: {
    approveAndReject: {
      isLoading: false,
      error: null,
      data: null
    },
    list: {
      isLoading: false,
      error: null,
      data: null
    }
  },
  updateUnifiedAlertStatus: {
    isLoading: true,
    error: null,
    data: null
  },
  commonKYCCustomers: {
    isLoading: true,
    error: null,
    data: null
  },
  dynPropCategories: {
    isLoading: false,
    error: null,
    data: null
  },
  dynProperties: {
    isLoading: false,
    error: null,
    data: null
  },
  pipelines: {
    isLoading: true,
    error: null,
    data: null
  },
  pipelinesRun: {
    isLoading: true,
    error: null,
    data: null
  },
  pipelinesSchedule: {
    isLoading: true,
    error: null,
    data: null
  },
  dynPropertiesUpdate: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: null
  },
  pipelinesHistory: {
    isLoading: true,
    error: null,
    data: null
  },
  commonKYCCustomersDownload: {
    isLoading: true,
    error: null,
    data: null
  },
  commonTypologyAction: {
    isLoading: true,
    error: null,
    data: []
  },
  commonNotifications: {
    isLoading: true,
    error: null,
    data: null
  },
  alertLevelConfigs: {
    isLoading: true,
    error: null,
    data: []
  }
};

function commonReducers(state = initialState, action) {
  switch (action.type) {
    case CLEAR_AMLS_COMMON_UNIFIED_ALERTS:
      return {
        ...state,
        unifiedAlerts: {
          ...initialState.unifiedAlerts
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS:
      return {
        ...state,
        unifiedAlerts: {
          ...initialState.unifiedAlerts
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS:
      return {
        ...state,
        unifiedAlerts: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL:
      return {
        ...state,
        unifiedAlerts: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case CLEAR_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION:
      return {
        ...state,
        unifiedAlertsPrevention: {
          ...initialState.unifiedAlertsPrevention
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS:
      return {
        ...state,
        unifiedAlertCounts: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_SUCCESS:
      return {
        ...state,
        unifiedAlertCounts: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_FAIL:
      return {
        ...state,
        unifiedAlertCounts: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION:
      return {
        ...state,
        unifiedAlertsPrevention: {
          ...initialState.unifiedAlertsPrevention
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS_PREVENTION:
      return {
        ...state,
        unifiedAlertsPrevention: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL_PREVENTION:
      return {
        ...state,
        unifiedAlertsPrevention: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_AMLS_COMMON_KYC_ALERTS:
      return {
        ...state,
        commonKYCCustomers: {
          ...initialState.commonKYCCustomers
        }
      };
    case GET_AMLS_COMMON_KYC_ALERTS_SUCCESS:
      return {
        ...state,
        commonKYCCustomers: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_KYC_ALERTS_FAIL:
      return {
        ...state,
        commonKYCCustomers: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD:
      return {
        ...state,
        commonKYCCustomersDownload: {
          ...initialState.commonKYCCustomersDownload
        }
      };
    case GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_SUCCESS:
      return {
        ...state,
        commonKYCCustomersDownload: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_FAIL:
      return {
        ...state,
        commonKYCCustomersDownload: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case FETCH_TRM_ACTIONS_OF_TYPOLOGIES:
      return {
        ...state,
        commonTypologyAction: {
          ...initialState.commonKYCCustomersDownload
        }
      };
    case FETCH_TRM_ACTIONS_OF_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        commonTypologyAction: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case FETCH_TRM_ACTIONS_OF_TYPOLOGIES_FAIL:
      return {
        ...state,
        commonTypologyAction: {
          isLoading: false,
          data: [],
          error: {
            ...action.payload
          }
        }
      };

    case GET_AMLS_COMMON_ALERT_DETAILS:
      return {
        ...state,
        alertDetails: {
          ...initialState.alertDetails
        }
      };
    case GET_AMLS_COMMON_ALERT_DETAILS_SUCCESS:
      return {
        ...state,
        alertDetails: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_ALERT_DETAILS_FAIL:
      return {
        ...state,
        alertDetails: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_ALERT_PARTY_IDENTITY:
      return {
        ...state,
        alertPartyIdentity: {
          ...initialState.alertPartyIdentity
        }
      };
    case GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_SUCCESS:
      return {
        ...state,
        alertPartyIdentity: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_FAIL:
      return {
        ...state,
        alertPartyIdentity: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS:
      return {
        ...state,
        alertAssocCustomers: {
          ...initialState.alertAssocCustomers
        }
      };
    case GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_SUCCESS:
      return {
        ...state,
        alertAssocCustomers: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_FAIL:
      return {
        ...state,
        alertAssocCustomers: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_TICKETS:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          list: {
            isLoading: true,
            error: null,
            data: null
          }
        }
      };
    case GET_AMLS_COMMON_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          list: {
            isLoading: false,
            error: null,
            data: action.payload
          }
        }
      };
    case GET_AMLS_COMMON_TICKETS_FAIL:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          list: {
            isLoading: false,
            error: { ...action.payload },
            data: null
          }
        }
      };
    case PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          approveAndReject: {
            isLoading: true,
            error: null,
            data: null,
            isSuccess: false
          }
        }
      };
    case PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_SUCCESS:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          approveAndReject: {
            isLoading: false,
            error: null,
            data: null,
            isSuccess: true
          }
        }
      };
    case RESET_AMLS_COMMON_APPROVE_AND_REJECT_TICKET:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          approveAndReject: {
            isLoading: false,
            error: null,
            data: null,
            isSuccess: false
          }
        }
      };
    case PUT_AMLS_COMMON_ALERT_PARTY_UPDATE:
      return {
        ...state,
        updateUnifiedAlertStatus: {
          ...initialState.alertAssocCustomers
        }
      };
    case PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_SUCCESS:
      return {
        ...state,
        updateUnifiedAlertStatus: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };

    case PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_FAIL:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          approveAndReject: {
            isLoading: false,
            error: null,
            data: null,
            isSuccess: false
          }
        }
      };
    case PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_FAIL:
      return {
        ...state,
        updateUnifiedAlertStatus: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_SANDBOX_UI:
      return {
        ...state,
        sandboxResult: {
          isLoading: true,
          error: null,
          data: {}
        }
      };
    case GET_AMLS_COMMON_SANDBOX_UI_SUCCESS:
      return {
        ...state,
        sandboxResult: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_SANDBOX_UI_FAIL:
      return {
        ...state,
        sandboxResult: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case RESET_AMLS_COMMON_SANDBOX_UI_RESULTS:
      return {
        ...state,
        sandboxResult: {
          isLoading: false,
          error: null,
          data: {}
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES:
      return {
        ...state,
        dynPropCategories: {
          isLoading: true,
          error: null,
          data: []
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_SUCCESS:
      return {
        ...state,
        dynPropCategories: {
          isLoading: false,
          error: null,
          data: [...action.payload]
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_FAIL:
      return {
        ...state,
        dynPropCategories: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES:
      return {
        ...state,
        dynProperties: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES_SUCCESS:
      return {
        ...state,
        dynProperties: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_DYNAMIC_PROPERTIES_FAIL:
      return {
        ...state,
        dynProperties: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case RESET_AMLS_COMMON_DYNAMIC_PROPERTIES:
      return {
        ...state,
        dynProperties: {
          isLoading: false,
          error: null,
          data: null
        }
      };
    case PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE:
      return {
        ...state,
        dynPropertiesUpdate: {
          isLoading: true,
          isSuccess: false,
          error: null,
          data: null
        }
      };
    case PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_SUCCESS:
      return {
        ...state,
        dynPropertiesUpdate: {
          isLoading: false,
          isSuccess: true,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_FAIL:
      return {
        ...state,
        dynPropertiesUpdate: {
          isLoading: false,
          isSuccess: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_RESET:
      return {
        ...state,
        dynPropertiesUpdate: {
          isLoading: false,
          isSuccess: false,
          error: null,
          data: null
        }
      };

    case GET_AMLS_COMMON_PIPELINES:
      return {
        ...state,
        pipelines: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_AMLS_COMMON_PIPELINES_SUCCESS:
      return {
        ...state,
        pipelines: {
          isLoading: false,
          error: null,
          data: [...action.payload]
        }
      };
    case GET_AMLS_COMMON_PIPELINES_FAIL:
      return {
        ...state,
        pipelines: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case POST_AMLS_COMMON_PIPELINES_RUN:
      return {
        ...state,
        pipelinesRun: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case POST_AMLS_COMMON_PIPELINES_RUN_SUCCESS:
      return {
        ...state,
        pipelinesRun: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case POST_AMLS_COMMON_PIPELINES_RUN_FAIL:
      return {
        ...state,
        pipelinesRun: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case POST_AMLS_COMMON_PIPELINES_SCHEDULE:
      return {
        ...state,
        pipelinesSchedule: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case POST_AMLS_COMMON_PIPELINES_SCHEDULE_SUCCESS:
      return {
        ...state,
        pipelinesSchedule: {
          isLoading: false,
          error: null,
          data: action.payload
        },
        pipelinesUnSchedule: {
          isLoading: false,
          error: null,
          data: null
        }
      };
    case POST_AMLS_COMMON_PIPELINES_SCHEDULE_FAIL:
      return {
        ...state,
        pipelinesSchedule: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case POST_AMLS_COMMON_PIPELINES_UNSCHEDULE:
      return {
        ...state,
        pipelinesUnSchedule: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_SUCCESS:
      return {
        ...state,
        pipelinesUnSchedule: {
          isLoading: false,
          error: null,
          data: action.payload
        },
        pipelinesSchedule: {
          isLoading: false,
          error: null,
          data: null
        }
      };
    case POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_FAIL:
      return {
        ...state,
        pipelinesUnSchedule: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO:
      return {
        ...state,
        pipelinesScheduleInfo: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_SUCCESS:
      return {
        ...state,
        pipelinesScheduleInfo: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_FAIL:
      return {
        ...state,
        pipelinesScheduleInfo: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case GET_AMLS_COMMON_PIPELINES_HISTORY:
      return {
        ...state,
        pipelinesHistory: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_AMLS_COMMON_PIPELINES_HISTORY_SUCCESS:
      return {
        ...state,
        pipelinesHistory: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_COMMON_PIPELINES_HISTORY_FAIL:
      return {
        ...state,
        pipelinesHistory: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case POST_AMLS_COMMON_PIPELINE_STOP:
      return {
        ...state,
        pipelineStop: {
          isLoading: true,
          error: null,
          data: null,
          requestCompleted: false
        }
      };
    case POST_AMLS_COMMON_PIPELINE_STOP_SUCCESS:
      return {
        ...state,
        pipelineStop: {
          isLoading: false,
          error: null,
          data: action.payload,
          requestCompleted: true
        }
      };
    case POST_AMLS_COMMON_PIPELINE_STOP_FAIL:
      return {
        ...state,
        pipelineStop: {
          isLoading: false,
          data: null,
          error: action.payload,
          requestCompleted: true
        }
      };
    case GET_AMLS_COMMON_NOTIFICATIONS:
      return {
        ...state,
        commonNotifications: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_AMLS_COMMON_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        commonNotifications: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_COMMON_NOTIFICATIONS_FAIL:
      return {
        ...state,
        commonNotifications: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case FETCH_AMLS_ALERT_LEVEL:
      return {
        ...state,
        alertLevelConfigs: {
          isLoading: true,
          error: null,
          data: []
        }
      };
    case FETCH_AMLS_ALERT_LEVELS_SUCCESS:
      return {
        ...state,
        alertLevelConfigs: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case FETCH_AMLS_ALERT_LEVELS_FAIL:
      return {
        ...state,
        alertLevelConfigs: {
          isLoading: false,
          data: [],
          error: action.payload
        }
      };
    default:
      return state;
  }
}

export default commonReducers;
